//  Auth
// export const baseURL = "http://127.0.0.1:8000/api";
export const baseURL = "https://ecommerce-backend-1-9ybo.onrender.com/api";

export const REGISTER = "register";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const CATEGORIES = "categories";
export const Cat = "category";
// products
export const PRO = "products";
export const Pro = "product";
export const LatestSales = "latest-sale";
export const Latest = "latest";
export const TopRatedAPI = "top-rated";



//  users 
export const USERS = "users";
export const USER = "user";
export const GOOGLE_CALL_BACK = "auth/google/callback";


export const CART = "/cart";
